export default __webpack_public_path__ + "static/media/1621.a3d2f7b2.png";